export default __webpack_public_path__ + "maps-examples-add-marker-symbol-960-05e478de4845cb08eb27cb91b67d5f97.webp";